import React, { useEffect, useState } from "react";
import './mDatePicker.scss';

function MDatePicker (props) {
  const [year, setYear] = useState(new Date().getFullYear());
  const [month, setMonth] = useState(new Date().getMonth());
  const [cData, setCData] = useState([]);
  const [showSetting, setShowSetting] = useState(false);
  const [selectDate, setSelectDate] = useState('');

  useEffect(() => {
    initCalendar();
  }, [month, year]);

  function initCalendar () {
    let tmpCD = [];
    let initDate = new Date(year, month, 1);
    let fdate = new Date(initDate.getFullYear(), initDate.getMonth(), 1);
    setMonth(fdate.getMonth());
    setYear(fdate.getFullYear());
    let ldate = new Date(fdate.getFullYear(), fdate.getMonth() + 1, 0);       
    let mLength = (ldate - fdate) / (1000 * 60 * 60 * 24);
    let weekLenght = Math.ceil((fdate.getDay() + 1 + mLength) / 7);
    let startDate = new Date(fdate.getFullYear(), fdate.getMonth(), 1 - fdate.getDay());
    for (let w = 0; w < weekLenght; w++) {
      for (let d = 0; d < 7; d++) {
        tmpCD.push({
          year: startDate.getFullYear(),
          month: startDate.getMonth(),
          day: startDate.getDate(),
          date: startDate,
          memo: [],
        })
        startDate = new Date(startDate.setDate(startDate.getDate() + 1));
      }
    }
    setCData(tmpCD);
  }

  function changeMonth(e) {
    setMonth(month => month + e);
  }

  function changeYear(e) {
    setYear(year => year + e)
  }

  function selectDay(e, d) {
    if (e.target.className.split(' ').find(d => d === 'title' || d === 'daynum')) {
      setSelectDate(`${d.year}-${d.month + 1}-${d.day}`)
      setShowSetting(false);

      if (props.selectDate) props.selectDate(d);
    }
  }

  return <div className="mDatePicker">
    <div className="mdpdisplay">
      {props.label ? <div className="label">{props.label}</div> : ''}
      <div className="input" onClick={() => setShowSetting(true)}>
        <div className="display">{selectDate}</div>
      </div>
    </div>
    { showSetting ?
    <div>
      <div className="mdpMain">
        <div className="dpymb">
          <div className="btn" onClick={() => changeYear(-1)}>{'<'}</div>
          <div>{year}</div>
          <div className="btn" onClick={() => changeYear(1)}>{'>'}</div>
          <div className="btn" onClick={() => changeMonth(-1)}>{'<'}</div>
          <div>{month + 1}</div>
          <div className="btn" onClick={() => changeMonth(1)}>{'>'}</div>
        </div>
        <div className="MDPBody">
          {cData.map((d, index) => {
            let cn = ['title'];
            switch (index % 7)
            {
              case 0: 
                cn.push('sunday');
                break;
              case 6: 
                cn.push('saturday');
                break;
              default:
                break;
            }

            let cdn = ['day']
            if (d.month != month) {
              cdn.push('notThisMonth');
            }

              return <div className={cdn.join(' ')} key={`${d.year}${d.month}${d.day}`} onClick={e => selectDay(e, d)}>
                <div className={cn.join(' ')}>
                  <div className="daynum">{`${d.day}`}</div>
                </div>
                <div className="memoList">
                </div>
              </div>
            })}
          </div>
      </div>
    </div> : ''
    }
  </div>
}

export default MDatePicker;